import { render, staticRenderFns } from "./SideNavLink.vue?vue&type=template&id=669fc620&"
import script from "./SideNavLink.vue?vue&type=script&lang=ts&"
export * from "./SideNavLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports